import elementStateToggle from '../../../../../../src24/js/modules/elementStateToggle';
import autoSubmitForm from '../../../../../../src24/js/modules/autoSubmitForm';
import sliderEventsTimeline from '../../../../../../src24/js/modules/sliderEventsTimeline';
import chartIntegration from '../../../../../../src24/js/modules/chartIntegration';
import courseSliderTabNavigation from '../../../../../../src24/js/modules/courseSliderTabNavigation';

window.addEventListener('load', () => {
    autoSubmitForm.init();
    chartIntegration.init('rgba(55, 128, 125, 1)', "'Bison',sans-serif");
    sliderEventsTimeline.init();
    courseSliderTabNavigation.init();
    elementStateToggle.init({
        triggerElementSelector: '.js-courseinfo-state-trigger',
        preventDefault: true,
        hasContextElement: {
            elements: '.js-courseinfo-state-context',
            attr: 'href',
        },
        toggleActiveElement: true,
        removeAllActiveClasses: true,
        hooks: {
            afterToggle: (() => {
                sliderEventsTimeline.sliderEventsTimeline.forEach((element) => {
                    element.swiper.update();
                });
            }),
        },
    });
});
